<template>

<div>
   
            <div v-if="ADMIN_SIGNIN_RES">
                <cSysDashboard></cSysDashboard>
            </div>
            <div v-if="GET_SIGNIN_RES">
                <cAgentDashboard></cAgentDashboard>
            </div>
            <CElementCover v-if="isLoading" :opacity="0.8"/>
    </div>
</template>
<script>
    import cSysDashboard from "../../components/dashboard/system/cSysDashboard";
    import cAgentDashboard from "../../components/dashboard/cAgentDashboard";
    
    import {mapActions, mapGetters} from "vuex";
    import BaseConfiguration from "../../config/base.js";
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../config/API_DATA";
    import Logger from "../../services/logger";
    import Router from '../../router'
    import {addClassToBody, removeClassBody} from "../../util/util.js";
    import {PATHNAME, COMPONENT_NAME, TOAST_TYPE} from '../../util/constants'
    import apiGetBalanceDetail from "../../services/apiGetBalanceDetail";
    import router, {navigate, goBack, updateCurrRouteQuery} from "../../router/index";
    import { VALIDATE_SUCCESS_RES, getErrorMessage } from "../../util/apiValidate";
import { restartWebsockets, reconnect } from '../../graphql/ApolloClient';
    export default {
        name: 'Dashboard',
        components: {
            cAgentDashboard,
            cSysDashboard,
            },
        data() {
            return {
                isLoading:true,
                search: null,
                isShowState: true,

                dayToDaySalesRes: null,
                isShowBookingDetail: false,
                agentBookingDetail: {
                    ticketedBookings: null,
                    pendingBookings: null
                },
                userLogoDet: {
                    //logoDet: null,
                    b2bCompanyFinancess: []
                },
                // TOAST_TYPE:TOAST_TYPE,


            }
        },
        // methods: {


    //         ...mapActions("sDashBoard", {

    //             SET_AGENT_FINANCE_RESPONSE: "SET_AGENT_FINANCE_RESPONSE"
    //         }),
    //         ...mapActions("sCSearch", {
    //             SET_SEARCH_OBJ: "SET_SEARCH_OBJ",

    //         }),

    //         ...mapActions("sCMultiCitySearch", {
    //             SET_ML_SEARCH_OBJ: "SET_ML_SEARCH_OBJ",

    //         }),



    //         async getBalanceDetail(pB2bid) {
    //             let returnValue;
    //             try {
    //                 let balanceReq = apiGetBalanceDetail.buildRequest(pB2bid);
    //                 if (balanceReq) {
    //                     let balanceRes = await apiGetBalanceDetail.getResponse(balanceReq);
    //                     if (VALIDATE_SUCCESS_RES(balanceRes)) {
    //                         returnValue = balanceRes.data.data;
    //                         this.SET_AGENT_FINANCE_RESPONSE(returnValue);
    //                     } else {
    //                         let error = getErrorMessage(balanceRes);
    //                         let isJwt = handleJWT(error);
    //                         if (!isJwt) {
    //                             this.showAlert(getErrorAlertValue(error));
    //                         }
    //                     }
    //                 } else {
    //                     throw "invalid request";
    //                 }
    //             } catch (err) {
    //                 let body = Logger.buildRequest(
    //                     FILE_NAME.DASHBOARD,
    //                     "error in  getBalanceDetail",
    //                     err.toString(),
    //                     " getBalanceDetail()",
    //                     LOG_TYPE.ERROR
    //                 );
    //                 Logger.getResponse(body);
    //             }
    //             return returnValue;
    //         },


    //         // test(){
    //         //   location.replace('http://xyz.ascent24.io/testPage.html');
    //         // },


    //         getTicketingCount(bookDet) {
    //             try {
    //                 if (BaseConfiguration.isDebug) console.log("getTicketingCount");
    //                 // let retValue;
    //                 let ticketed = 0;
    //                 let pending = 0;
    //                 if (bookDet) {
    //                     for (let index = 0; index < bookDet.length; index++) {
    //                         const book = bookDet[index];
    //                         ticketed = ticketed + parseInt(book.ticketedbookings);
    //                         pending = pending + parseInt(book.pendingbookings);
    //                     }
    //                 }
    //                 this.agentBookingDetail.ticketedBookings = ticketed;
    //                 this.agentBookingDetail.pendingBookings = pending;
    //                 this.isShowBookingDetail = true;

    //             } catch (err) {
    //                 let body = Logger.buildRequest(
    //                     COMPONENT_NAME.DASHBOARD,
    //                     "error in getTicketingCount",
    //                     err.toString(),
    //                     "getTicketingCount",
    //                     LOG_TYPE.ERROR
    //                 );
    //                 Logger.getResponse(body);
    //             }
    //             // return retValue;
    //         },
    //         //to asign search history to search values
    //         assignHistoryToSearch(pHstryObj) {
    //             if (BaseConfiguration.isDebug) console.log("assignHistoryToSearch");
    //             try {
    //                 if (pHstryObj != null) {
    //                     this.isShowState = false;
    //                     let searchObj = this.setValidTravelDate(pHstryObj);
    //                     this.search = JSON.parse(JSON.stringify(searchObj));
    //                     let that = this;
    //                     setTimeout(function () {
    //                         that.isShowState = true;
    //                     });
    //                 }
    //             } catch (err) {
    //                 let body = Logger.buildRequest(
    //                     FILE_NAME.SEARCHPAGE,
    //                     "error in asignHistoryToSearch",
    //                     err.toString(),
    //                     "asignHistoryToSearch",
    //                     LOG_TYPE.ERROR
    //                 );
    //                 Logger.getResponse(body);
    //             }
    //         },
    //         //to navigate to search result page
    //         navToResultPage(pSearchObj, isMLSearch) {
    //             try {
    //                 if (BaseConfiguration.isDebug) console.log("navToResultPage");
    //                 if (pSearchObj) {
    //                     this.search = pSearchObj;

    //                     if (isMLSearch) {
    //                         this.SET_ML_SEARCH_OBJ(this.search)
    //                         navigate(PATHNAME.ML_FLIGHTRESULTS);
    //                     } else {
    //                         this.SET_SEARCH_OBJ(this.search);
    //                         navigate(PATHNAME.FLIGHTRESULTS);

    //                     }


    //                 } else {
    //                     this.showToast(
    //                         " Invalid search Object",
    //                         TOAST_TYPE.ERROR,
    //                         1000,
    //                         null
    //                     );
    //                 }
    //                 // if (this.storeSearchHistory(this.search)) {

    //                 //  }
    //             } catch (err) {
    //                 let body = Logger.buildRequest(
    //                     FILE_NAME.SEARCHPAGE,
    //                     "error while navigation",
    //                     err.toString(),
    //                     "navToResultPage",
    //                     LOG_TYPE.ERROR
    //                 );
    //                 Logger.getResponse(body);
    //             }
    //         },


    //         getSearchHistory(pUserId) {
    //             if (BaseConfiguration.isDebug) console.log("getSearchHistory");
    //             try {
    //                 let sHistory = [];
    //                 if (pUserId) {
    //                     let history = JSON.parse(
    //                         getFlightSearchHisFromLocal(pUserId)
    //                     );
    //                     if (history) {
    //                         sHistory = history
    //                     }
    //                 }
    //                 return sHistory;
    //             } catch (err) {
    //                 let body = Logger.buildRequest(
    //                     FILE_NAME.SEARCHPAGE,
    //                     "error in getSearchHistory",
    //                     err.toString(),
    //                     "getSearchHistory",
    //                     LOG_TYPE.ERROR
    //                 );
    //                 Logger.getResponse(body);
    //             }
    //         },
    //         setValidTravelDate(pHistoryObj) {
    //             try {
    //                 let historyObj = JSON.parse(JSON.stringify(pHistoryObj));
    //                 if (historyObj.route && historyObj.route.length > 0) {
    //                     if (historyObj.route[0] && historyObj.route[0].date) {
    //                         if (
    //                             getDiffBtwDates(
    //                                 new Date(historyObj.route[0].date),
    //                                 new Date(),
    //                                 "days"
    //                             ) >= 0
    //                         ) {
    //                             historyObj.route[0].date = new Date(historyObj.route[0].date);
    //                         } else {
    //                             historyObj.route[0].date = new Date();
    //                         }
    //                     }
    //                     if (historyObj.route[1] && historyObj.route[1].date) {
    //                         if (
    //                             getDiffBtwDates(
    //                                 new Date(historyObj.route[1].date),
    //                                 new Date(historyObj.route[0].date),
    //                                 "days"
    //                             ) >= 0
    //                         ) {
    //                             historyObj.route[1].date = new Date(historyObj.route[1].date);
    //                         } else {
    //                             historyObj.route[1].date = new Date(addDays(new Date(historyObj.route[0].date), 7));
    //                         }
    //                     }
    //                 }

    //                 return historyObj;
    //             } catch (err) {
    //                 let body = Logger.buildRequest(
    //                     FILE_NAME.SEARCHPAGE,
    //                     "error in setValidTravelDate",
    //                     err.toString(),
    //                     "setValidTravelDate",
    //                     LOG_TYPE.ERROR
    //                 );
    //                 Logger.getResponse(body);
    //             }
    //         },

    //     },


        computed: {
            ...mapGetters("sSysLogin", {
                ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
            }),
            ...mapGetters("sDashBoard", {
                userLogoDetail: "GET_AGENT_LOGO_DET_RES",
            }),
            ...mapGetters('sAgtLogin', {GET_SIGNIN_RES: 'GET_SIGNIN_RES'}),
            ...mapGetters("sDashBoard", {
                USER_ID: "GET_USER_ID"
            })

        },

        beforeCreate() {
            addClassToBody(COMPONENT_NAME.DASHBOARD);
        },

        beforeDestroy() {
            removeClassBody();
        },
        async created() {
            // if (BaseConfiguration.isDebug) console.log("created");
            try {
                reconnect();
                this.$root.$emit("toggle-sidebar-minimize", true);
                let that = this;
               setTimeout(function(){
                    that.isLoading = false;
               },1200);
                /* for (let index = 0; index < 25; index++) {
      throw 'reference Error'

    }  */


                // if (this.userLogoDetail && this.GET_SIGNIN_RES)
                //     this.userLogoDet.b2bCompanyFinancess = await this.getBalanceDetail(this.userLogoDetail.b2bid ? this.userLogoDetail.b2bid : null);
                // if (this.userLogoDet.b2bCompanyFinancess) {
                //     this.getTicketingCount(this.userLogoDet.b2bCompanyFinancess);
                // }


                // let userId;
                // if (this.USER_ID) {
                //     userId = this.USER_ID;
                // }
                // this.searchHistory = this.getSearchHistory(userId);
                // if (this.searchHistory.length > 0) {
                //     this.assignHistoryToSearch(this.searchHistory[this.searchHistory.length - 1].search)
                // }
                

            } catch (err) {
                let body = Logger.buildRequest(
                    FILE_NAME.DASHBOARD,
                    "error in created",
                    err.toString(),
                    "created",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }

        }

    }
</script>
<style>
    [v-cloak].c-sidebar c-sidebar-dark c-sidebar-show c-sidebar-fixed {
        display: none;
    }
</style>
